import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Repayments(state = initialState, action) {
  switch (action.type) {
    case userConstants.REPAYMENTS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.REPAYMENTS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.REPAYMENTS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}